<template>
	<div class="sch">
		<div class="sch-month">
			{{ month.name }}
		</div>
		<div class="sch-body">
			<div class="sch-nav">
				<div class="sch-navLeft" @click="prev"></div>
				<div class="sch-navRight" @click="next"></div>
			</div>
			<div class="sch-overflow">
				<week
					:type="type"
					:date="date"
					:count="count"
					:selected_date="selected_date"
					@input="selected_date = $event"
				></week>
				<template v-if="type === '0'">
					<sessions
						v-for="(item, key) in items"
						:key="key"
						:items="item"
						:time="key"
						:selected="selected"
						v-on:select="select"
						v-on:unselect="unselect"
					></sessions>
				</template>
				<template v-else>
					<times
						:items="items"
						:workers_id="workers_id"
						:date="selected_date"
						:time="time"
						v-model="time"
						@book="book"
					></times>
					<equipments
						v-if="time && equipments_items.length > 0"
						:items="equipments_items"
						:equipments_id="equipments_id"
						v-model="equipments_id"
						@book="book"
					></equipments>
				</template>
				<popup v-if="isBook" @close="clearSelection">
					<book
						:item="session"
						:workers_id="workers_id"
						:type="type"
						:equipments_id="equipments_id"
						:services_id="services_id"
					></book>
				</popup>
			</div>
		</div>
	</div>
</template>

<script>
import helper from '@/plugins/helper.js';
import _ from 'lodash';

import week from '@/components/schedule/week.vue';
import sessions from '@/components/schedule/sessions.vue';
import times from '@/components/schedule/times.vue';
import equipments from '@/components/schedule/equipments.vue';
import book from '@/components/schedule/book.vue';

export default {
	props: {
		type: {
			//тип расписания
			/*
					0 - список сеансов всех услуг с возможностью записи
					1 - список сеансов доступных к созданию в услуге
				*/
			default: '0',
		},
		count: {
			//количество дней в расписании
			default: 9,
		},
		workers_id: {
			//выбранный сотрудник
			default: '0',
		},
		sessions: {
			default() {
				return [];
			},
		},
		services_id: {
			//выбранная услуга
			default: '0',
		},
	},
	components: { week, sessions, times, equipments, book },
	data() {
		return {
			date: new Date(),
			time: null, //выбранное время сеанса
			equipments_id: [],
			selected: null, //id открытого сеанса
			selected_date: new Date(), //выбранный день
		};
	},
	mounted() {
		if (this.$route.query.date) {
			this.selected_date = new Date(this.$route.query.date);
		}
	},
	computed: {
		month() {
			return helper.getYearMonth(this.date);
		},
		equipments_items() {
			let service = _.find(this.$store.state.services.items, item => item.id === this.services_id),
				items = service ? service.equipments.slice() : [];
			_.each(items, item => {
				let eq = _.find(this.$store.state.sessions.clientsEquipments, i => {
					return i.equipments_id === item.id;
				});
				item.full = typeof eq != 'undefined';
			});
			return items;
		},
		items() {
			let items = {};
			if (this.type === '0') {
				_.each(this.$store.getters['schedule/getSessions'], item => {
					if (typeof items[item.time] === 'undefined') {
						items[item.time] = {};

						let date = new Date(this.date);
						for (let i = 0; i < this.count; i++) {
							items[item.time][helper.dateFormat(date)] = [];
							date.setDate(date.getDate() + 1);
						}
					}

					if (typeof items[item.time][item.date] !== 'undefined') items[item.time][item.date].push(item);
				});
			} else {
				_.each(this.$store.getters['schedule/getSessions'], item => {
					if (typeof items[item.workers_id] === 'undefined') {
						items[item.workers_id] = {};

						let date = new Date(this.date);
						for (let i = 0; i < this.count; i++) {
							items[item.workers_id][helper.dateFormat(date)] = [];
							date.setDate(date.getDate() + 1);
						}
					}

					if (typeof items[item.workers_id][item.date] !== 'undefined')
						items[item.workers_id][item.date].push(item);
				});
			}

			return items;
		},
		session() {
			// return {
			// 	services_id: this.services_id,
			// 	workers_id: this.workers_id,
			// 	date: this.selected_date,
			// 	time: this.time,
			// 	equipments_id: this.equipments_id
			// }
			return _.find(
				this.$store.state.schedule.sessions,
				item =>
					item.services_id === this.services_id &&
					(item.workers_id === this.workers_id || this.workers_id === '0') &&
					item.date === helper.dateFormat(this.selected_date) &&
					item.timestamp === this.time
			);
		},
		isBook() {
			return this.book();
		},
	},
	methods: {
		next() {
			let date = new Date(this.date);
			date.setDate(this.date.getDate() + 1);
			this.date = date;
		},
		prev() {
			let date = new Date(this.date);
			date.setDate(this.date.getDate() - 1);
			this.date = date;
		},
		emitInput() {
			if (
				this.$store.state.user.id === '' ||
				(this.$store.state.user.phone && this.$store.state.user.phone.length > 5)
			) {
				this.$emit('input', {
					date: this.date,
					time: this.time,
					equipments_id: this.equipments_id,
					count: this.count,
					workers_id: this.workers_id,
					selected_date: this.selected_date,
				});
			} else {
				helper.notice({ text: 'Необходимо указать свой номер телефона' }).then(() => {
					this.$router.push('/profile');
				});
			}
		},
		select(item) {
			this.selected = item.id;
		},
		unselect() {
			this.selected = null;
		},
		book() {
			if (this.workers_id && this.services_id && this.selected_date && this.time) {
				if (this.equipments_items.length > 0) {
					if (this.equipments_id.length === 0) return false;
				}
				/* wip if (!this.$store.state.user.id) {
					this.$router.push('/profile/login');
					return false;
				}*/
				return true;
			}
			return false;
		},
		clearSelection() {
			this.time = '';
			this.equipments_id = [];
		},
		loadClientsEquipments() {
			if (this.equipments_items.length > 0) {
				this.$store.commit('sessions/clearClientsEquipments');
				this.$store.dispatch('api/send', {
					task: 'getClientsEquipments',
					data: this.session,
				});
			}
		},
	},
	watch: {
		date() {
			this.clearSelection();
			this.emitInput();
		},
		selected_date() {
			this.clearSelection();
			this.emitInput();
			this.$emit('dateChange', this.selected_date);
			let query = this.$route.query;
			this.$router.push({ query: { ...query, date: helper.dateFormat(this.selected_date) } });
		},
		time() {
			this.equipments_id = [];
			this.emitInput();
			this.loadClientsEquipments();
			//this.book();
		},
		equipments_id() {
			this.emitInput();
			//this.book();
		},
	},
};
</script>
